import { render, staticRenderFns } from "./ChatPreview.vue?vue&type=template&id=02d41dad"
import script from "./ChatPreview.vue?vue&type=script&lang=ts"
export * from "./ChatPreview.vue?vue&type=script&lang=ts"
import style0 from "./ChatPreview.vue?vue&type=style&index=0&id=02d41dad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
